import { useState, useEffect, useRef } from 'react';

import { IMG } from '../../const';
import './video.scss';

const CircleVideo = () => {
  const videoRef = useRef(null);
  const circleRef = useRef(null);
  const rafRef = useRef(null); // variable to store the animation frame ID
  const [isMute, setMute] = useState(true);

  const progressWrapperSize = 310;
  const progressRadius = 145;
  const circumference = 2 * Math.PI * progressRadius;

  useEffect(() => {
    const update = () => {
      const video = videoRef.current;
      const circle = circleRef.current;

      if (video && video.duration && circle) {
        circle.style.strokeDashoffset = `${
          circumference * (1 - video.currentTime / video.duration)
        }`;
      }
      // to store the animation frame ID in ref
      rafRef.current = requestAnimationFrame(update);
    };

    rafRef.current = requestAnimationFrame(update);

    return () => cancelAnimationFrame(rafRef.current);
  }, [circumference]);

  const toggleSound = () => {
    setMute(!isMute);
  };

  return (
    <div className="circle-video-wrapper">
      <svg
        viewBox={`0 0 ${progressWrapperSize} ${progressWrapperSize}`}
        width={progressWrapperSize}
        height={progressWrapperSize}
      >
        <circle
          className="progress"
          cx={progressWrapperSize / 2}
          cy={progressWrapperSize / 2}
          fill="none"
          r={progressRadius}
          strokeWidth="20"
          stroke="white"
          strokeOpacity="0.6"
          strokeDasharray={`${circumference}`}
          ref={circleRef}
        />
      </svg>

      <div className="circle-video">
        <video
          ref={videoRef}
          muted={isMute}
          autoPlay
          loop
          playsInline
          preload="metadata"
        >
          <source
            src={`${IMG.QUICK_QUOTE}/video/video_intro.mp4`}
            type="video/mp4"
          />
          <source
            src={`${IMG.QUICK_QUOTE}/video/video_intro.ogv`}
            type="video/ogg"
          />
          <source
            src={`${IMG.QUICK_QUOTE}/video/video_intro.webm`}
            type="video/webm"
          />
        </video>
        <button
          type="button"
          title={`Volume ${isMute ? 'on' : 'off'}`}
          className={`volume-play-icon ${isMute ? 'mute' : ''}`}
          onClick={toggleSound}
        />
      </div>
    </div>
  );
};

export default CircleVideo;
